import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const VideoReview = ({ video }) => {
  const [isPlaying, setIsPlaying] = useState(false);

  const handlePlayVideo = () => {
    setIsPlaying(true);
  };

  return (
    <div className="bg-white rounded-xl shadow-subtle border border-border p-6 mb-8">
      <div className="flex items-center gap-3 mb-6">
        <div className="flex items-center justify-center w-10 h-10 bg-accent/10 rounded-lg">
          <Icon name="Play" size={20} className="text-accent" />
        </div>
        <div>
          <h2 className="text-xl font-bold text-text-primary">Video Review</h2>
          <p className="text-sm text-muted-foreground">Watch our comprehensive testing process</p>
        </div>
      </div>
      <div className="relative aspect-video bg-muted rounded-lg overflow-hidden">
        {!isPlaying ? (
          <div className="relative w-full h-full">
            <div
              className="w-full h-full bg-cover bg-center"
              style={{ backgroundImage: `url(${video?.thumbnail})` }}
            />
            <div className="absolute inset-0 bg-black/30 flex items-center justify-center">
              <Button
                variant="default"
                size="lg"
                iconName="Play"
                iconPosition="left"
                onClick={handlePlayVideo}
                className="bg-white/90 text-text-primary hover:bg-white"
              >
                Play Video ({video?.duration})
              </Button>
            </div>
            <div className="absolute bottom-4 left-4 bg-black/70 text-white px-3 py-1 rounded-lg text-sm">
              {video?.duration}
            </div>
          </div>
        ) : (
          <iframe
            width="100%"
            height="100%"
            src={video?.embedUrl}
            title={video?.title}
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
            className="w-full h-full"
          />
        )}
      </div>
      <div className="mt-4 space-y-4">
        <div>
          <h3 className="font-semibold text-text-primary mb-2">{video?.title}</h3>
          <p className="text-sm text-muted-foreground leading-relaxed">
            {video?.description}
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
          {video?.highlights?.map((highlight, index) => (
            <div key={index} className="text-center p-3 bg-muted/30 rounded-lg">
              <Icon name={highlight?.icon} size={20} className="text-primary mx-auto mb-2" />
              <div className="text-sm font-medium text-text-primary">{highlight?.title}</div>
              <div className="text-xs text-muted-foreground">{highlight?.timestamp}</div>
            </div>
          ))}
        </div>

        <div className="flex items-center justify-between pt-4 border-t border-border">
          <div className="flex items-center gap-4">
            <div className="flex items-center gap-2">
              <Icon name="Eye" size={16} className="text-muted-foreground" />
              <span className="text-sm text-muted-foreground">{video?.views} views</span>
            </div>
            <div className="flex items-center gap-2">
              <Icon name="Calendar" size={16} className="text-muted-foreground" />
              <span className="text-sm text-muted-foreground">{video?.publishDate}</span>
            </div>
          </div>
          
          <div className="flex items-center gap-2">
            <Button variant="ghost" size="sm" iconName="ThumbsUp" iconPosition="left">
              {video?.likes}
            </Button>
            <Button variant="ghost" size="sm" iconName="Share2" iconPosition="left">
              Share
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default VideoReview;